<template>
  <div class="review">
      <div class="search">
            <el-date-picker
            style="margin-right:1%"
            v-model="startTime"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="提交日期">
            </el-date-picker>
        <span class="demonstration" style="line-height: 38px;font-size: 14px;">至</span>
            <el-date-picker
            style="margin-left:1%"
            v-model="endTime"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="提交日期">
            </el-date-picker>
          <el-input v-model="orderid" placeholder="订单号"></el-input>
          <el-input v-model="name" placeholder="客户姓名"></el-input>
          <el-input v-model="carnum" placeholder="车架号"></el-input>
          <el-input v-model="compay" placeholder="金融公司"></el-input>
          <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
      </div>
      <div class="listbtn">
        <el-button  v-preventReClick type="primary" @click="pays()">支付</el-button>    
      </div>
     
      <div class="tablelist">
          <el-table
            :data="tableData"
            :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
            style="width: 100%"
             @selection-change="handleSelectionChange">
            <el-table-column
            type="selection"
            width="55">
            </el-table-column>
             <el-table-column
                prop="saleCode"
                label="订单号"
                width="200">
            </el-table-column>
            <el-table-column
                prop="name"
                width="150"
                label="车主姓名">
            </el-table-column>
            <el-table-column
               width="150"
                prop="phone"
                label="手机号">
            </el-table-column>
            <el-table-column
               width="150"
                prop="carModelOne"
                label="汽车车型">
                <template slot-scope="scope">
                    {{scope.row.carModelOne+scope.row.carModelTwo}}
                </template>
            </el-table-column>
            <el-table-column
               width="150"
                prop="vin"
                label="车架号">
            </el-table-column>
            <el-table-column
               width="150"
                prop="productName"
                label="产品名称">
            </el-table-column>
            <el-table-column
               width="150"
                prop="saleType"
                label="订单类型">
                <template slot-scope="scope">
                     {{scope.row.saleType == 1 ?'销售':scope.row.saleType == 2?'续费':'销售'}}
                </template>
            </el-table-column>
            <el-table-column
             width="120"
                prop="submitDate"
                label="提交日期">
            </el-table-column>
            <el-table-column
                width="200"
                prop=""
                label="操作">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="look(scope.row)">查看</el-link>
                    <el-link :underline="false" @click="pay(scope.row)">支付</el-link>
                    <el-link :underline="false" @click="cancel(scope.row)">取消订单</el-link>
                </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="page">
          <el-pagination
            :background="true"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
      </div>
      <!-- 月结支付弹框 -->
      <el-dialog
        title="月结支付"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="30%"
        >
        <span>您当前的订单支付方式为月结，确认支付选中的订单吗？</span>
        <p style="margin-top:10px">订单总额为：{{totalMoney}}元</p>
        <span slot="footer" class="dialog-footer">
            <el-button  v-preventReClick @click="dialogVisible = false">取 消</el-button>
            <el-button  v-preventReClick type="primary" @click="sure()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 预付款 -->
      <el-dialog
        title="预付款支付"
        :visible.sync="dialogVisible1"
        :close-on-click-modal="false"
        width="30%"
        >
        <span>您当前的订单支付方式为预付款，确认支付选中的订单吗？</span>
        <p style="margin-top:10px">您的余额为：{{balance}}元，需支付的费用为：{{totalMoney}}元</p>
        <span slot="footer" class="dialog-footer">
            <el-button  v-preventReClick @click="dialogVisible1 = false">取 消</el-button>
            <el-button  v-preventReClick type="primary" @click="sure()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 扫码付款 -->
      <el-dialog
        title="扫码支付"
        :visible.sync="dialogVisible2"
        :close-on-click-modal="false"
        width="30%"
        :before-close="handleClose"
        >
        <span>请打开微信或支付宝，进行扫码支付，您需支付的费用为：{{totalMoney}}元</span>
         <div id="qrCode" ref="qrCodeDiv" style="margin-top:25px;text-align: center;"></div>
        <span slot="footer" class="dialog-footer">
            <el-button  v-preventReClick @click="codecancel()">取 消</el-button>
            <!-- <el-button  v-preventReClick type="primary" @click="sure()">确 定</el-button> -->
        </span>
      </el-dialog>
  </div>
</template>

<script>
import {getselllist,cancelorder,advancepayment,tradeno,paymentgo} from '../axios/api'
import QRCode from 'qrcodejs2';
export default {
    data(){
        return{
            orderid:'',
            name:'',
            carnum:'',
            compay:'',
            value2: '',
            tableData:[],
            multipleSelection:[],
            currentPage4: 1,
            total:0,
            page:1,
            dialogVisible:false,
            dialogVisible1:false,
            dialogVisible2:false,
            startTime:'',
            endTime:'',
            totalMoney:'',
            balance:'',
            jiaoyinum:'',
            saleId:'',
            states:0,
            statementAccountId:''
        }
    },
    created(){
        this.getdata()
    },
    methods:{
        codecancel(){
            this.dialogVisible2 = false
            this.getdata()
        },
        handleClose(){
            this.dialogVisible2 = false
            this.getdata()
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.page = val
            if(this.states == 0){
                this.getdata()
            }else{
                this.search1()
            }
        },
        look(row){
            this.$router.push({
                name:'订单详情',
                params:{
                    code:row.saleCode,
                    id:row.id
                }
            })
        },
        cancel(row){
            console.log(row)
            this.$confirm('确认取消订单吗?', '取消订单', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal:false,
                type: 'warning'
                }).then(async () => {
                    var {data:dt} = await cancelorder({
                        id:row.saleId
                    })
                    console.log(dt)
                    if(dt.code == 200){
                        this.$message({
                            type: 'success',
                            message: dt.message
                        });
                        this.getdata()
                    }else{
                        this.$message.error(dt.message)
                    }
                   
                }).catch(() => {       
            });
        },
        async pay(row){
            this.saleId = row.saleId
            var {data:dt} = await advancepayment({
                saleIds:row.saleId,
                shopId:Number(window.localStorage.getItem('shopId'))
            })
            console.log(dt)
            if(dt.code == 200){
                if(dt.data.clearingFromType == 1){
                    this.dialogVisible = true
                }else if(dt.data.clearingFromType == 2){
                    this.dialogVisible1 = true
                }else if(dt.data.clearingFromType == 3){
                    this.dialogVisible2 = true
                }
                this.balance = dt.data.balance
                this.totalMoney = dt.data.totalMoney
                this.statementAccountId = dt.data.statementAccountId
                var {data:dt1} = await tradeno({})
                console.log(dt1)
                this.jiaoyinum = dt1.data.data
                if(dt.data.qrcode){
                    console.log(document.getElementById("qrCode").innerHTML)
                    document.getElementById("qrCode").innerHTML = "";
                    console.log(JSON.parse(dt.data.qrcode))
                    if(JSON.parse(dt.data.qrcode).billQRCode){
                        new QRCode(this.$refs.qrCodeDiv, {
                        text: JSON.parse(dt.data.qrcode).billQRCode,
                        width: 200,
                        height: 200,
                        colorDark: "#333333", //二维码颜色
                        colorLight: "#ffffff", //二维码背景色
                        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                        });
                    }else{
                        this.$message.error(JSON.parse(dt.data.qrcode).errMsg)
                    }
                    
                }
            }else{
                this.$message.error(dt.message)
                this.getdata()
            }
            
           
        },
        async pays(){
            if(this.multipleSelection.length !== 0){
                var {data:dt2} = await advancepayment({
                    saleIds:this.saleId,
                    shopId:Number(window.localStorage.getItem('shopId'))
                })
                console.log(dt2)
                if(dt2.code == 200){
                    if(dt2.data.clearingFromType == 1){
                        this.dialogVisible = true
                    }else if(dt2.data.clearingFromType == 2){
                        this.dialogVisible1 = true
                    }else if(dt2.data.clearingFromType == 3){
                        this.dialogVisible2 = true
                    }
                    this.balance = dt2.data.balance
                    this.totalMoney = dt2.data.totalMoney
                    this.statementAccountId = dt2.data.statementAccountId
                    var {data:dt1} = await tradeno({})
                    console.log(dt1)
                    this.jiaoyinum = dt1.data.data
                    if(dt2.data.qrcode){
                        console.log(document.getElementById("qrCode").innerHTML)
                        document.getElementById("qrCode").innerHTML = "";
                        console.log(JSON.parse(dt2.data.qrcode))
                        if(JSON.parse(dt2.data.qrcode).billQRCode){
                            new QRCode(this.$refs.qrCodeDiv, {
                            text: JSON.parse(dt2.data.qrcode).billQRCode,
                            width: 200,
                            height: 200,
                            colorDark: "#333333", //二维码颜色
                            colorLight: "#ffffff", //二维码背景色
                            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                            });
                        }else{
                            this.$message.error(JSON.parse(dt2.data.qrcode).errMsg)
                        }
                    
                }
                    // var {data:dt1} = await tradeno({})
                    // console.log(dt1)
                    // if(dt1.code == 200){
                    //     var {data:dt} = await paymentgo({
                    //         saleIds:this.multipleSelection.toString(),
                    //         shopId:window.localStorage.getItem('shopId'),
                    //         totalMoney:this.totalMoney,
                    //         tradeNo:dt1.data.data
                    //     })
                    //     console.log(dt)
                    //     if(dt.code == 200){
                    //         this.dialogVisible = false
                    //         this.dialogVisible1 = false
                    //         this.dialogVisible2 = false
                    //         this.$message.success(dt.message)
                    //         this.getdata()
                    //     }
                    // }
                }
                
            }else{
                this.$message.warning('请选择要支付的订单')
            }
            
        },
        async sure(){
            var {data:dt1} = await tradeno({})
            console.log(dt1)
            if(dt1.code == 200){
                var {data:dt} = await paymentgo({
                    saleIds:this.saleId,
                    shopId:window.localStorage.getItem('shopId'),
                    totalMoney:this.totalMoney,
                    tradeNo:dt1.data.data,
                    // statementAccountId:this.statementAccountId
                })
                console.log(dt)
                if(dt.code == 200){
                    this.dialogVisible = false
                    this.dialogVisible1 = false
                    this.dialogVisible2 = false
                    this.$message.success(dt.message)
                    this.getdata()
                }else{
                    this.$message.error(dt.message)
                }
            }
        },
        handleSelectionChange(val) {
            console.log(val)
            this.multipleSelection = val.map(item=>{
                return item.id
            })
            this.saleId = this.multipleSelection.toString()
            console.log(this.saleId)
        },
        async getdata(){
            this.states = 0
            var {data:dt} = await getselllist({
                current:this.page,
                limit:10,
                state:3,
                shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.total = dt.data.page.total
                this.tableData = dt.data.page.records
            }
        },
        async search(){
            this.states = 1
            var {data:dt} = await getselllist({
                startSubmitDate:this.startTime,
                endSubmitDate:this.endTime,
                code:this.orderid,
                name:this.name,
                vin:this.carnum,
                financialCompany:this.compay,
                state:3,
                current:1,
                limit:10,
                 shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.page = 1
                this.total = dt.data.page.total
                this.tableData = dt.data.page.records
            }
        },
        async search1(){
            this.states = 1
            var {data:dt} = await getselllist({
                startSubmitDate:this.startTime,
                endSubmitDate:this.endTime,
                code:this.orderid,
                name:this.name,
                vin:this.carnum,
                financialCompany:this.compay,
                state:3,
                current:this.page,
                limit:10,
                 shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.total = dt.data.page.total
                this.tableData = dt.data.page.records
            }
        }
    }
}

</script>
<style lang="less" scoped>
.review{
   background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link.el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    } 
}
</style>
<style>
.el-date-range-picker{
        z-index: 9999999!important;
}
.el-date-range-picker__editors-wrap .el-date-range-picker__time-picker-wrap:nth-child(2){
    display: none;
    /* display: ; */
}
#qrCode img{
    margin: 0 auto;
}
</style>